export default __webpack_public_path__ + "static/media/16-EXT-(2-1).bf5930ca.jpg";